import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormPaymentRecord from '../../forms/FormPaymentRecord.jsx';

const PagePaymentRecord = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/paymentRecords/${_id}` });
    }
  }, [_id]);

  const breadcrumb =
    _id === 'self'
      ? []
      : [{ to: '../', children: 'PaymentRecords' }];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Payment Record</Header>
      <FormPaymentRecord />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormPaymentRecord paymentRecord={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PagePaymentRecord;
